// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"281":"3aece717","478":"3aece717","7406":"741088df","9113":"3aece717"}[chunkId] + ".chunk.css";
};